import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LoanApplicationNote } from '../../cmg-1003/models/notes.model';
import { iStoreActions } from '../../loan-state/core/store-actions.interface';

function createInitialState(): LoanApplicationNote {
  return <LoanApplicationNote>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-application-notes' })
export class ApplicationNotesDataStore extends Store<LoanApplicationNote> implements iStoreActions<LoanApplicationNote> {
  private _initValue: LoanApplicationNote = null;
  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<LoanApplicationNote>, updatedModel: LoanApplicationNote) => {
    return updatedModel;
  };

  get initialValue() {
    return this._initValue;
  }
}
